/**
 * Minni Mow - Scroll Dropdown & Card Animation Engine
 * Handles smooth scroll physics, dropdown menus, and card cascade effects.
 */
(function() {
  'use strict';

  function initMinniEngine() {
    // 1. SCROLL DROPDOWN CASCADE ANIMATIONS FOR CARDS
    const dropItems = document.querySelectorAll(
      '.minni-scroll-drop-item, .card-wrapper.product-card-wrapper, .featured-collection .grid__item'
    );

    if (dropItems.length > 0) {
      if ('IntersectionObserver' in window) {
        const dropObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-dropped');
              entry.target.classList.add('animate-drop-in');
              observer.unobserve(entry.target);
            }
          });
        }, {
          root: null,
          rootMargin: '100px 0px 50px 0px',
          threshold: 0.05
        });

        dropItems.forEach((item, index) => {
          if (!item.style.getPropertyValue('--card-index')) {
            item.style.setProperty('--card-index', (index % 6).toString());
          }
          dropObserver.observe(item);
        });
      } else {
        dropItems.forEach(item => {
          item.classList.add('is-dropped');
          item.classList.add('animate-drop-in');
        });
      }
    }

    // 2. INTERACTIVE CATEGORIES & COLLECTION DROPDOWN BUTTONS
    const dropdownBtns = document.querySelectorAll('.minni-categories-dropdown-btn, .minni-collection-dropdown-btn');
    dropdownBtns.forEach(btn => {
      // Ensure single listener attachment
      if (btn.getAttribute('data-minni-init') === 'true') return;
      btn.setAttribute('data-minni-init', 'true');

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const parentWrapper = btn.closest('.minni-categories-dropdown-wrapper, .minni-collection-dropdown-wrap');
        if (!parentWrapper) return;

        const wasOpen = parentWrapper.classList.contains('is-open');

        // Close any other open dropdowns first
        document.querySelectorAll('.minni-categories-dropdown-wrapper.is-open, .minni-collection-dropdown-wrap.is-open').forEach(w => {
          if (w !== parentWrapper) {
            w.classList.remove('is-open');
            const otherBtn = w.querySelector('button');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle this dropdown
        if (wasOpen) {
          parentWrapper.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          parentWrapper.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // 3. DROPDOWN ITEMS CLICK & SMOOTH JUMP
    const dropItemsLinks = document.querySelectorAll('.minni-cat-dropdown-item');
    dropItemsLinks.forEach(link => {
      if (link.getAttribute('data-minni-init') === 'true') return;
      link.setAttribute('data-minni-init', 'true');

      link.addEventListener('click', function(e) {
        const targetId = this.getAttribute('data-target-card');
        if (targetId) {
          const targetEl = document.getElementById(targetId);
          if (targetEl) {
            e.preventDefault();
            const wrapper = this.closest('.minni-categories-dropdown-wrapper, .minni-collection-dropdown-wrap');
            if (wrapper) {
              wrapper.classList.remove('is-open');
              const btn = wrapper.querySelector('button');
              if (btn) btn.setAttribute('aria-expanded', 'false');
            }
            targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            targetEl.classList.add('is-highlighted');
            setTimeout(() => targetEl.classList.remove('is-highlighted'), 1600);
          }
        }
      });
    });

    // 4. GLOBAL OUTSIDE CLICK LISTENER TO CLOSE DROPDOWNS
    if (!window._minniOutsideClickBound) {
      window._minniOutsideClickBound = true;
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.minni-categories-dropdown-wrapper, .minni-collection-dropdown-wrap')) {
          document.querySelectorAll('.minni-categories-dropdown-wrapper.is-open, .minni-collection-dropdown-wrap.is-open').forEach(w => {
            w.classList.remove('is-open');
            const btn = w.querySelector('button');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          });
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('.minni-categories-dropdown-wrapper.is-open, .minni-collection-dropdown-wrap.is-open').forEach(w => {
            w.classList.remove('is-open');
            const btn = w.querySelector('button');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMinniEngine);
  } else {
    initMinniEngine();
  }

  // Support Shopify Theme Customizer events
  document.addEventListener('shopify:section:load', initMinniEngine);
  document.addEventListener('shopify:section:select', initMinniEngine);
})();
